import { getSearchConfig } from "@/components/dynamic-form/helper/getSearchConfig";
import { getTranslateNsT } from "@/utils/getTranslateNsT";
import { getToday, ONE_WEEK } from "@/utils/date-formatter/getToday";
import { SearchBarType } from "@/components/dynamic-form/constants";
import dayjs from "project-config/utils/dayjs";
import { useAccountOptions } from "@/pages/consumption/hooks/useAccountOptions";
import { usePlatformOptions } from "@/pages/consumption/hooks/usePlatformOptions";

export function useSearchConfig() {
  const accountOptions = useAccountOptions();
  const platformOptions = usePlatformOptions();

  const searchConfig = getSearchConfig(() => {
    const t = getTranslateNsT("consumption");
    const centerT = getTranslateNsT("center");

    const now = getToday();
    const weekAgo = new Date(now.getTime() - ONE_WEEK);

    return [
      {
        type: SearchBarType.DatePicker,
        field: "time",
        label: t("consumption_time_selector"),
        limitMonthNum: 3,
        isTrendsChangeDate: true,
        props: {
          allowClear: false,
          defaultValue: [dayjs(weekAgo), dayjs(now)],
        },
      },
      {
        type: SearchBarType.Select,
        label: t("user_operate_record_user_name"),
        field: "userId",
        props: {
          allowClear: true,
          options: accountOptions,
          placeholder: t("consume_pick_platform_all"),
        },
      },
      {
        type: SearchBarType.Select,
        field: "platform",
        label: centerT("user_consume_pick_platform"),
        props: {
          options: platformOptions,
          placeholder: centerT("custom_display_text_all"),
        },
      },
      {
        type: SearchBarType.Select,
        label: t("consumption_label_fee_type"),
        field: "feeType",
        props: {
          placeholder: t("user_consume_pick_platform_all"),
          dropdownMatchSelectWidth: false,
          options: [
            {
              label: t("consumption_fee_type_0"),
              value: 0,
            },
            {
              label: t("consumption_fee_type_1"),
              value: 1,
            },
          ],
        },
      },
    ];
  });

  return { searchConfig };
}
